import { render, staticRenderFns } from "./InputAction.vue?vue&type=template&id=03180559&lang=pug&"
import script from "./InputAction.vue?vue&type=script&lang=js&"
export * from "./InputAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports